import {
  SamplesByColumn,
  SamplesSource,
} from 'notebook/sample-propagation/sample-collection/SamplesSourceCollector';
import {isFilterInSampleFilters, SampleFilter} from 'notebook/sample-propagation/SampleFilter';

/**
 * Returns the sources that contain at least one column which matches one of the destination filters.
 * Transforms each returned source so that their `samplesByColumn` field only contains the columns that match one of the destination filters.
 * Returns sources unfiltered if destinationFilters is null.
 */
export default function filterSamplesSources(
  sources: Array<SamplesSource>,
  destinationFilters: Array<SampleFilter> | null
): Array<SamplesSource> {
  return sources
    .map((source) => ({
      ...source,
      samplesByColumn: filterSampleColumns(source.samplesByColumn, destinationFilters),
    }))
    .filter((source) => source.samplesByColumn.length > 0);
}

/**
 * Returns the samplesByColumn that can match at least one destination filter.
 * Returns samplesByColumns unfiltered if destinationFilters is null.
 */
export function filterSampleColumns(
  samplesByColumn: Array<SamplesByColumn>,
  destinationFilters: Array<SampleFilter> | null
): Array<SamplesByColumn> {
  if (destinationFilters == null) {
    return samplesByColumn;
  }

  return samplesByColumn.filter((samplesByColumn) =>
    isFilterInSampleFilters(destinationFilters, [samplesByColumn.sampleFilter])
  );
}
